// @ts-check

/**
 * @typedef FullName
 * @property {string} firstName User's first name
 * @property {string} lastName Users' last name
 */

/**
 * Extracts first and last names from the full name of a user
 * @param {string} fullName
 * @returns {FullName}
 */
export const getFirstAndLastNames = (fullName = '') => {
  const nameParts = fullName.split(' ');
  const [firstName] = nameParts;
  const lastName = nameParts.pop();

  return { firstName, lastName };
};
